import React, {useMemo, useCallback} from "react";
import {Checkbox} from "antd";
import StyleBorders from "./StyleBorders";
import {
    buildColoursConfig,
    manageColours,
    getColourOnColour,
    getRGBFromRGBA,
    ensureColourContrast,
} from "./ManageColours";
import {ExampleBlockBody} from "../../../lesson/lessonContentStyleGuide/LessonContentStyleGuide";
import {ContentStylesColourBlock, ContentStylesDemoSubsection} from "../ContentStylesHelper";

const EDIT_TYPES = {
    BLOCK: "cont-block-custom-*",
    MAIN: "cont-block-custom-*-main-colour",
    ON_MAIN: "cont-block-custom-*-on-main-colour",
    BG: "cont-block-custom-*-bg-colour",
    ON_BG: "cont-block-custom-*-on-bg-colour",
}

export const customBlockStylesRegistry = {
    [EDIT_TYPES.BLOCK]: {title: 'Custom block @', slave: EDIT_TYPES.MAIN},
    [EDIT_TYPES.MAIN]: {title: 'Main', cssVar: ['--cont-block-*-colour', '--cont-block-*-colour-RGB'], mainColour: true},
    [EDIT_TYPES.ON_MAIN]: {title: 'On main', cssVar: ['--cont-on-block-*-colour'], autoGenerated: true},
    [EDIT_TYPES.BG]: {title: 'Background', cssVar: ['--cont-block-*-bg'], autoGenerated: true},
    [EDIT_TYPES.ON_BG]: {title: 'On background', cssVar: ['--cont-on-block-*-bg'], autoGenerated: true},
}

export const CustomBlockStyles = props => {
    const {editCategory, variant, updateStylesCallback} = props;

    const coloursConfig = useMemo(() => buildColoursConfig(customBlockStylesRegistry, variant), [variant]);
    const generateColours = useCallback((mainColour) => ({
        [EDIT_TYPES.ON_MAIN]: getColourOnColour(mainColour),
        [EDIT_TYPES.BG]: getRGBFromRGBA(mainColour, .1),
        [EDIT_TYPES.ON_BG]: ensureColourContrast(mainColour, getRGBFromRGBA(mainColour, .1))
    }), []);
    const {colours, updateColours, toggleGeneratedColours} = manageColours(
        editCategory,
        coloursConfig,
        generateColours,
        updateStylesCallback
    );

    const allAuto = colours[EDIT_TYPES.ON_MAIN]?.autoGenerated &&
        colours[EDIT_TYPES.BG]?.autoGenerated &&
        colours[EDIT_TYPES.ON_BG]?.autoGenerated;
    const anyAuto = colours[EDIT_TYPES.ON_MAIN]?.autoGenerated ||
        colours[EDIT_TYPES.BG]?.autoGenerated ||
        colours[EDIT_TYPES.ON_BG]?.autoGenerated;

    return (
        <>
            <h5>Colours</h5>
            <ContentStylesColourBlock
                editType={EDIT_TYPES.MAIN}
                variant={variant}
                colourConfig={customBlockStylesRegistry[EDIT_TYPES.MAIN]}
                colours={colours}
                onChange={updateColours}
            />
            <Checkbox
                indeterminate={anyAuto && !allAuto}
                checked={allAuto}
                onChange={(event) => toggleGeneratedColours(event.target.checked)}
            >
                Auto generated colours
            </Checkbox>
            <span className="ch-text-small margin-t--s">* Color can be auto-generated based on main color.</span>
            <ContentStylesColourBlock
                editType={EDIT_TYPES.ON_MAIN}
                variant={variant}
                colourConfig={customBlockStylesRegistry[EDIT_TYPES.ON_MAIN]}
                colours={colours}
                onChange={updateColours}
            />
            <ContentStylesColourBlock
                editType={EDIT_TYPES.BG}
                variant={variant}
                colourConfig={customBlockStylesRegistry[EDIT_TYPES.BG]}
                colours={colours}
                onChange={updateColours}
            />
            <ContentStylesColourBlock
                editType={EDIT_TYPES.ON_BG}
                variant={variant}
                colourConfig={customBlockStylesRegistry[EDIT_TYPES.ON_BG]}
                colours={colours}
                onChange={updateColours}
            />
            {/*<StyleBorders*/}
            {/*    defaultValues={{*/}
            {/*        border: {*/}
            {/*            [`--block-border-width`]: styles[`--block-border-width`],*/}
            {/*            [`--block-border-colour`]: styles[`--block-border-colour`]*/}
            {/*        },*/}
            {/*        radius: {*/}
            {/*            [`--block-border-radius-tl`]: styles[`--block-border-radius-tl`],*/}
            {/*            [`--block-border-radius-tr`]: styles[`--block-border-radius-tr`],*/}
            {/*            [`--block-border-radius-bl`]: styles[`--block-border-radius-bl`],*/}
            {/*            [`--block-border-radius-br`]: styles[`--block-border-radius-br`]*/}
            {/*        }*/}
            {/*    }}*/}
            {/*    onChange={updateStylesCallback}*/}
            {/*/>*/}
        </>
    )
}

export const CustomBlockDemo = props => {
    const {demoEvents, totalVariants} = props;

    return (
        <ContentStylesDemoSubsection>
            {[...Array(totalVariants)].map((_, i) => {
                const variantNum = i + 1;
                const classKey = `cont-block-custom-${variantNum}`;
                const groupKey = `customBlocks${variantNum}`;

                return (
                    <div
                        key={classKey}
                        id={`preview-section-${groupKey}`}
                        className={`cont-block ${classKey}`}
                        {...demoEvents(classKey)}
                    >
                        <div className='cont-block-head'>
                            Custom block {variantNum}
                        </div>
                        <div className='cont-block-body'>
                            <ExampleBlockBody />
                        </div>
                    </div>
                );
            })}
        </ContentStylesDemoSubsection>
    )
};